import React from 'react';

import routes from 'js/core_pre_webpack/routes';
import { TextButtonLink } from 'js/design_system/link/TextButtonLink';

import { NewUserDiscount } from './types';
import PremiumLock from './PremiumLock';

type PremiumTextProps = {
  reactivate?: string;
  coupon?: string;
  newUserDiscount?: NewUserDiscount;
  trialPricingCopy?: string;
};

const PremiumText = ({
  reactivate,
  coupon,
  newUserDiscount,
  trialPricingCopy,
}: PremiumTextProps) => {
  let url;
  let ctaText;

  if (trialPricingCopy) {
    ctaText = trialPricingCopy;
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'nav-btn-trial',
      from_navbar: true,
    });
  } else if (newUserDiscount) {
    const { feature, trigger, couponCode } = newUserDiscount;
    url = routes.checkout_url({
      feature,
      trigger,
      coupon_code: couponCode,
      from_navbar: true,
    });
    ctaText = '6 Months Free!';
  } else if (reactivate) {
    url = routes.checkout_url({
      feature: 'default',
      trigger: 'nav-btn-reactivate',
      premium_discount_coupon: coupon,
      from_navbar: true,
    });
    ctaText = 'Reactivate 50% Off';
  } else {
    url = routes.upgrade_url({
      feature: 'default',
      trigger: 'default',
      from_navbar: true,
    });
    ctaText = 'Get Premium';
  }

  return (
    <TextButtonLink
      href={url}
      icon={<PremiumLock circleColor="gold" lockColor="white" />}
    >
      {ctaText}
    </TextButtonLink>
  );
};

export default PremiumText;
